import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { AuthService, TranslationService } from 'src/app/shared';
import { WebsiteServiceApiService } from 'src/app/shared/api/website-service-api.service';

@Component({
  selector: 'wl-banner-ads-embed-code-dialog',
  templateUrl: './banner-ads-embed-code-dialog.component.html',
  styleUrl: './banner-ads-embed-code-dialog.component.less',
    standalone: false
})
export class BannerAdsEmbedCodeDialogComponent implements OnInit {
  showDialog: boolean = false;
  bannerNames: SelectItem[];
  bannerNameSelected: string;
  keywords: string;
  embedCodeGenerated: string;

  constructor(
    private _translationService: TranslationService,
    private _authService: AuthService,
    private _apiService: WebsiteServiceApiService
  ) {}

  async ngOnInit() {
    let leaderboard = await this._translationService.getTitlecase('banner-ads.embed-code-dialog.banner-name-leaderboard');
    let square1 = await this._translationService.getTitlecase('banner-ads.embed-code-dialog.banner-name-square1');
    let square2 = await this._translationService.getTitlecase('banner-ads.embed-code-dialog.banner-name-square2');
    this.bannerNames = [
      { value: leaderboard, label: leaderboard } as SelectItem,
      { value: square1, label: square1 } as SelectItem,
      { value: square2, label: square2 } as SelectItem,
    ];
  }

  open() {
    this.showDialog = true;
  }

  close() {
    this.keywords = null;
    this.bannerNameSelected = null;
    this.embedCodeGenerated = null;
    this.showDialog = false;
  }

  generateEmbedCode() {

    let websiteServiceApiBaseUrl = this._apiService.getBaseUrl();
    let tenant = this._authService.getTenant();

    let dimensions = this.bannerNameSelected === 'Leaderboard' ? 'width="970px" height="90px"' : 'width="300px" height="250px"';
    let websiteService = `${websiteServiceApiBaseUrl}/website/v2/BannerAd/generatebanner?x-tenant=${tenant}&bannerName=${this.bannerNameSelected}&keyword=${this.keywords}`;
    this.embedCodeGenerated = `<div style="position: absolute; top: 0px; left: 0px;"><iframe src="${websiteService}"
    style="border:0px #ffffff none;" name="iframe" ${dimensions} scrolling="no" frameborder="0" marginheight="0px" marginwidth="0px"></iframe></div>`;
  }
}
